













































































import {SERVER_HOST_QR} from '@/config';
import {Component, Prop, Vue} from 'vue-property-decorator';
import axios from 'axios';

@Component({
  name: "QrProduct"
})
export default class QrProduct extends Vue {
  @Prop({type: String, default: null}) show!: string | null
  @Prop({type: String, default: null}) params!: string | null
  item:any = {}

  TranslateType(str:string){
    let val:string = ''
    switch (str){
      case 'phone':
        val =  'Телефон'
        break;
      case 'email':
        val =  'Email'
        break;
      case 'site':
        val =  'Сайт'
        break;
    }
    return val
  }


  async getDataFromServer() {
    try {
      const {data} = await axios.get(SERVER_HOST_QR+ 'product/' + this.params )
      if (data.status != 'err') {
        this.item = data
        this.$emit('addItemsFromStorage',
          {
            path:this.$route.path,
            obj:{
              type:'product',
              name:  this.item.title,
              company:data.company.title
            }
          }
        )
      } else {
        this.$emit('showError')

      }
    } catch (e) {
      this.$emit('showError')
      console.log(e)
    }
  }

  mounted() {
    this.getDataFromServer()
  }
}
